import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Pricing() {
  const pricingSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "EnteliPro AI ERP & CRM Software",
    "description": "Comprehensive AI ERP and CRM software platform offering automated financial management, sales pipeline tracking, inventory control, and workforce management.",
    "brand": {
      "@type": "Brand",
      "name": "EnteliPro"
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Free Demo / Starter",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Full access free trial with core ERP & CRM modules."
      },
      {
        "@type": "Offer",
        "name": "Professional Plan",
        "price": "49",
        "priceCurrency": "USD",
        "description": "Ideal for growing businesses requiring AI insights and automated workflows."
      },
      {
        "@type": "Offer",
        "name": "Enterprise AI Plan",
        "price": "199",
        "priceCurrency": "USD",
        "description": "Unlimited modules, custom API integrations, and 24/7 dedicated support."
      }
    ]
  };

  return (
    <>
      <SEO
        title="AI ERP & CRM Software Pricing Plans"
        description="Explore transparent pricing plans for EnteliPro AI ERP & CRM software. Choose from Starter, Professional, and Enterprise plans with AI automation and predictive analytics."
        keywords="AI ERP Software Pricing, CRM Software Plans, Cloud ERP Pricing, Enterprise Software Cost, AI CRM Solutions for Small Business"
        canonical="https://www.entelipro.com/pricing"
        schema={pricingSchema}
      />

      <Navbar />

      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Pricing</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Pricing Header & Tiers */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          <div className="main-titles-head text-center mb-5">
            <h1 className="header-name" style={{ fontSize: "2.5rem", fontWeight: "700", marginBottom: "15px" }}>
              AI ERP & CRM Software Pricing Plans
            </h1>
            <p className="para" style={{ maxWidth: "750px", margin: "0 auto", fontSize: "1.1rem" }}>
              Flexible, transparent plans designed for businesses of all sizes. Scale with AI-powered ERP automation, predictive customer analytics, and dedicated support.
            </p>
          </div>

          <div className="row justify-content-center">
            {/* Free Trial / Starter */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 shadow-sm border-0 p-4" style={{ borderRadius: "12px" }}>
                <div className="card-body d-flex flex-column">
                  <h3 className="card-title text-primary font-weight-bold" style={{ fontSize: "1.4rem" }}>
                    Free Demo / Starter
                  </h3>
                  <p className="text-muted">Perfect for small teams testing AI ERP & CRM capabilities.</p>
                  <div className="my-3">
                    <span style={{ fontSize: "2.5rem", fontWeight: "700" }}>$0</span>
                    <span className="text-muted"> / 30-Day Trial</span>
                  </div>
                  <ul className="list-unstyled mb-4 text-left">
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Core CRM & Lead Management</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Contact & Task Tracking</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Basic Financial Invoicing</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Community & Email Support</li>
                  </ul>
                  <div className="mt-auto">
                    <Link to="/register" className="btn btn-outline-primary btn-block w-100 py-2" style={{ fontWeight: "600" }}>
                      Start Free Trial
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Professional Plan */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 shadow border-primary p-4" style={{ borderRadius: "12px", borderWidth: "2px" }}>
                <div className="card-body d-flex flex-column position-relative">
                  <span className="badge bg-primary text-white position-absolute" style={{ top: "-28px", right: "20px", padding: "6px 14px", borderRadius: "20px" }}>
                    Most Popular
                  </span>
                  <h3 className="card-title text-primary font-weight-bold" style={{ fontSize: "1.4rem" }}>
                    Professional
                  </h3>
                  <p className="text-muted">For expanding businesses automating sales and supply operations.</p>
                  <div className="my-3">
                    <span style={{ fontSize: "2.5rem", fontWeight: "700" }}>$49</span>
                    <span className="text-muted"> / user / month</span>
                  </div>
                  <ul className="list-unstyled mb-4 text-left">
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Everything in Starter</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> AI Sales Forecasting & Automation</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Full Inventory & Warehouse Control</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> 360-Degree Customer Intelligence</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Priority 24/7 Email & Phone Support</li>
                  </ul>
                  <div className="mt-auto">
                    <Link to="/register" className="btn btn-primary btn-block w-100 py-2 text-white" style={{ fontWeight: "600" }}>
                      Get Started
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Enterprise Plan */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 shadow-sm border-0 p-4" style={{ borderRadius: "12px" }}>
                <div className="card-body d-flex flex-column">
                  <h3 className="card-title text-primary font-weight-bold" style={{ fontSize: "1.4rem" }}>
                    Enterprise AI
                  </h3>
                  <p className="text-muted">For enterprises needing bespoke AI models and ERP architecture.</p>
                  <div className="my-3">
                    <span style={{ fontSize: "2.5rem", fontWeight: "700" }}>Custom</span>
                    <span className="text-muted"> / tailored deployment</span>
                  </div>
                  <ul className="list-unstyled mb-4 text-left">
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> All Professional Features</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> EyeSense AI Surveillance Integration</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Custom DB & Cloud API Integrations</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Multi-Tenant Data Management</li>
                    <li className="mb-2"><span className="fa fa-check text-success mr-2"></span> Dedicated Enterprise Account Manager</li>
                  </ul>
                  <div className="mt-auto">
                    <Link to="/contact_us" className="btn btn-outline-primary btn-block w-100 py-2" style={{ fontWeight: "600" }}>
                      Contact Sales
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="w3l-contact-info-main py-5">
        <div className="contact-sec">
          <div className="container">
            <div className="main-titles-head text-center mb-4">
              <h2 className="header-name" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                Have Questions About EnteliPro Pricing?
              </h2>
              <p className="para">Our team is available 24/7 to assist with custom quotes and product walkthroughs.</p>
            </div>

            <div className="contact row text-center">
              {/* email */}
              <div className="col-lg-3 col-md-6 col-sm-6 contact-grids mb-4">
                <div className="contact-gtids p-3 shadow-sm bg-white" style={{ borderRadius: "8px" }}>
                  <span className="fa fa-envelope fa-2x text-primary mb-2" aria-hidden="true"></span>
                  <h4>Email Address</h4>
                  <a href="mailto:support@entelipro.com">
                    <p className="contact-text-sub">support@entelipro.com</p>
                  </a>
                  <a href="mailto:info@entelipro.com">
                    <p className="contact-text-sub">info@entelipro.com</p>
                  </a>
                </div>
              </div>

              {/* phone */}
              <div className="col-lg-3 col-md-6 col-sm-6 contact-grids mb-4">
                <div className="contact-gtids p-3 shadow-sm bg-white" style={{ borderRadius: "8px" }}>
                  <span className="fa fa-phone fa-2x text-primary mb-2" aria-hidden="true"></span>
                  <h4>Phone Number</h4>
                  <a href="tel:+917676289081">
                    <p className="contact-text-sub">+91 7676289081</p>
                  </a>
                </div>
              </div>

              {/* address */}
              <div className="col-lg-3 col-md-6 col-sm-6 contact-grids mb-4">
                <div className="contact-gtids p-3 shadow-sm bg-white" style={{ borderRadius: "8px" }}>
                  <span className="fa fa-building fa-2x text-primary mb-2" aria-hidden="true"></span>
                  <h4>Address Line</h4>
                  <p className="contact-text-sub">
                    Manyata Embassy Business Park, Nagavara, Bengaluru, Karnataka 560045
                  </p>
                </div>
              </div>

              {/* 24/7 support */}
              <div className="col-lg-3 col-md-6 col-sm-6 contact-grids mb-4">
                <div className="contact-gtids p-3 shadow-sm bg-white" style={{ borderRadius: "8px" }}>
                  <span className="fa fa-headphones fa-2x text-primary mb-2" aria-hidden="true"></span>
                  <h4>Support</h4>
                  <p className="contact-text-sub">
                    24/7 Dedicated Support Team Ready For You.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
